/*
author: umer shabir.
file: doctor availability module: It will set time slots for doctor avaialabilty schedule.
date: 16-08-2022.
*/
// dependencies
import React, { useState } from 'react'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TextField, Modal, Box } from '@mui/material'
import moment from 'moment'

// Add time slot object
export default function AddTimeSlot({ addTimeSlot, itemIndex, activeForm, item, duration, appointmentType = 'legacy', weekArray }) {
  const [showModal, setShowModal] = useState(false)
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  const [error, setError] = useState(null)



  const handleOpenModal = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setError(null)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setStartTime(null)
    setEndTime(null)
    setError(null)
  }

  const handleAddSlot = () => {
    try {
      setError(null)
      if (!startTime || !endTime) {
        setError('Please select both start and end time')
        return
      }

      const formattedStart = moment(startTime.$d || startTime).format('HH:mm')
      const formattedEnd = moment(endTime.$d || endTime).format('HH:mm')

      addTimeSlot(
        {
          startTime: formattedStart,
          endTime: formattedEnd,
        },
        itemIndex,
        appointmentType,
        weekArray
      )

      setStartTime(null)
      setEndTime(null)
      setShowModal(false)
    } catch (err) {
      setError(err.message || 'Error adding time slot. Please try again.')
    }
  }

  return (
    <>
      <button
        className='custom-button btn d-flex justify-content-end align-items-center'
        type='button'
        disabled={false}
        onClick={handleOpenModal}
        style={{ color: '#009B94', columnGap: '10px', cursor: 'pointer' }}
      >
        <i className='fas fa-plus'></i> Add Time Slot
      </button>

      {/* Time Picker Modal */}
      <Modal 
        open={showModal} 
        onClose={handleCloseModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: 450,
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            p: 4,
            maxHeight: '90vh',
            overflowY: 'auto',
            outline: 'none',
          }}
        >
          <h5 className='mb-4' style={{ color: '#009B94', fontWeight: 'bold', fontSize: '18px' }}>
             Add Time Slot
          </h5>

          {error && (
            <div style={{ color: 'red', padding: '10px', backgroundColor: '#ffe0e0', borderRadius: '4px', marginBottom: '15px' }}>
              <small>{error}</small>
            </div>
          )}

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600', color: '#333', fontSize: '14px' }}>
              Start Time
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                value={startTime}
                onChange={setStartTime}
                label='Select Start Time'
                minutesStep={5}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size='small'
                    variant='outlined'
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#009B94',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#009B94',
                        },
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '10px', fontWeight: '600', color: '#333', fontSize: '14px' }}>
              End Time
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                value={endTime}
                onChange={setEndTime}
                label='Select End Time'
                minutesStep={5}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size='small'
                    variant='outlined'
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                          borderColor: '#009B94',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#009B94',
                        },
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          {duration && (
            <div style={{ padding: '12px', backgroundColor: '#E0F3F2', borderRadius: '4px', marginBottom: '24px', borderLeft: '4px solid #009B94' }}>
              <small style={{ color: '#009B94', fontWeight: '600' }}>
                ⏱️ Slot Duration: {duration} minutes
              </small>
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              className='btn'
              type='button'
              onClick={handleCloseModal}
              style={{
                border: '1px solid #ddd',
                padding: '8px 24px',
                borderRadius: '4px',
                cursor: 'pointer',
                backgroundColor: '#f9f9f9',
                color: '#666',
                fontWeight: '500',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f0f0f0'
                e.target.style.borderColor = '#999'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#f9f9f9'
                e.target.style.borderColor = '#ddd'
              }}
            >
              Cancel
            </button>
            <button
              className='btn'
              type='button'
              onClick={handleAddSlot}
              style={{
                backgroundColor: '#009B94',
                color: 'white',
                padding: '8px 24px',
                borderRadius: '4px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '600',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#007A72'
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#009B94'
              }}
            >
              Add Slot
            </button>
          </div>
        </Box>
      </Modal>
    </>
  )
}
//
